import type { FaireProductEntity } from "../../entity_types/product";

export const p_cybgv72eqj: FaireProductEntity = {
  token: "p_cybgv72eqj",
  type: "product",
  name: "Trinite 18K Gold Non-Tarnish Cross Pendant Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/9135b61ea2db75a7854cf73bd0ba8b7308e406eda6688b1d0d25b8b52b1af129.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b07420d50ee5ea41bff2d0ae65f7969daa0640ffe4bde94da070fc33e8624cb.jpeg",
    "https://cdn.faire.com/fastly/ea7fe096fa5fb2f8bf74e4869f9d76e9147d289e423effdea3b16df4165373c5.jpeg",
    "https://cdn.faire.com/fastly/ef4aa816f0a63e755fa36acb27a7fc3ac1fefe952a21b88e3306a98e6608f2e7.jpeg",
  ],
  priceDollars: 13.65,
  description:
    "18K Gold Non-Tarnish Cross Pendant Necklace\n8K Gold Plating\nStainless Steel\nPendant Size (inch): 1.26\nChain Length (inch): 16.53\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:40.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
